import { createContext, useState } from "react";
import { AppConfigType, DropdownType } from "../constants/types";

const defaultAppConfig: AppConfigType = {
  config: {
    genderOptions: [],
    maritalstatusOptions: [],
    bloodgroupOptions: [],
    memberrelationOptions: [],
    memberstatusOptions: [],
    langaugeOptions: [],
    educationOptions: [],
    occupationOptions: [],
  },
  setConfig: () => {},
  lastUpdatedAt: 0,
  setLastUpdatedAt: () => {},
};

export const AppConfigContext = createContext(defaultAppConfig);

const AppConfigProvider = ({ children }: { children: any }) => {
  const [config, setConfig] = useState<{
    genderOptions: DropdownType[];
    maritalstatusOptions: DropdownType[];
    bloodgroupOptions: DropdownType[];
    memberrelationOptions: DropdownType[];
    memberstatusOptions: DropdownType[];
    langaugeOptions: DropdownType[];
    educationOptions: DropdownType[];
    occupationOptions: DropdownType[];
  }>(defaultAppConfig.config);
  const [lastUpdatedAt, setLastUpdatedAt] = useState<number>(0);

  const appConfigValue: AppConfigType = {
    config,
    setConfig,
    lastUpdatedAt,
    setLastUpdatedAt,
  };

  return (
    <AppConfigContext.Provider value={appConfigValue}>
      {children}
    </AppConfigContext.Provider>
  );
};

export default AppConfigProvider;
